<template>
    <div class="guide-article">
        <guideWelcome :article="guide.article" />
        <div class="img-copyright f7" v-if="guide.article.imageCopyright" v-html="guide.article.imageCopyright"></div>
        <div class="static-section">
            <div class="static-gs guide-article-one">
                <div class="static-section">
                    <guideAuthorInfo />
                    <guideNavigation />
                </div>
                <div class="static-section middle-section">
                    <guideArticleContent />
                    <cardSection data-nosnippet v-if="guide.marketOverviewInfo && guide.marketOverviewInfo.length" :data="guide.marketOverviewInfo" :title="`${glb.geo.city}, ${glb.geo.state} Market Overview`"></cardSection>
                    <div class="relative-spacing rArticle">
                        <div class="f4">Related Articles</div>
                        <guideArticleCard class="static-gs gs-sm-2 relative-spacing" theme="related" :articles="relatedArticleCards" />
                        <ul>
                            <li v-for="relatedArticle in relatedArticleLinks">
                                <a class="link" :href="glb.appUrl+relatedArticle.url">{{relatedArticle.title}}</a>
                            </li>
                        </ul>
                    </div>
                    <guideArticleListingSeo />
                    <guideArticleNearBySeo class="linkSpacing" />
                </div>
                <div class="static-section">
                    <div class="static-gs relative-spacing" v-if="officeData" >
                        <a class="link" :href="glb.appUrl + officeData.url">Movoto {{ officeData.displayName }} Office</a>
                    </div>
                     <div data-nosnippet class="nearby-section" v-if="path.city ? getShowList('url', 'city') : getShowList('location')">
                        <div class="gx-full">
                            <h2 class="f4">Nearby Homes for Sale</h2>
                        </div>
                        <mvtLazyload ref="lazyloadNearby" :async="true" data-role="propertycard">
                            <mvtNearby :type="path.city ? 'city' : 'location'" filterPath="/pagesize-10/" @completed="completed" carousalType="for_sale"></mvtNearby>
                        </mvtLazyload>
                     </div>

                    <div class="static-gs relative-spacing" v-if="guide.relatedArticles">
                        <div class="f4">Related Articles</div>
                        <guideArticleCard class="static-gs gs-sm-2 relative-spacing rArticle-right" theme="small" :articles="guide.relatedArticles.slice(0, 10)" />
                    </div>
                    <template v-if="path.condo">
                            <div data-nosnippet class="nearby-section" v-if="getShowList('condos', 'city')">
                                <div class="gx-full">
                                    <h2 class="f4">Nearby Condos</h2>
                                </div>
                                <mvtLazyload ref="lazyloadNearbyCondos" :async="true" data-role="propertycard">
                                    <mvtNearby type="city" filterPath="/condos/pagesize-10/" @completed="completed" carousalType="condos"></mvtNearby>
                                </mvtLazyload>
                            </div>
                     </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./theme-one.js"></script>

<style lang="scss">
@use "./theme-one.scss" as *;
</style>